import api from "../components/customAxios/Axios";

import { useEffect, useState } from "react";
import { useLoader } from "@/context/loaderContext";
import { useParams } from "react-router-dom";
import AssessmentForm from "../components/Application/AssessmentForm";
import { useToast } from "../components/toast";
import useBreadCrumb from "@/context/BreadCrumbContext";
interface AssessmentSection {
	checkSection: boolean;
	numQuestions: string;
	questionLevel: string;
	topic: string;
	codingLanguage: string;
}

interface AssessmentConfig {
	cutOfScore: string;
	validity_days: string;
	behavioralAssessment: AssessmentSection;
	technicalAssessment: AssessmentSection;
	codingAssessment: AssessmentSection;
}



const GenerateAssessmentLaterPage = () => {

	const { setBreadCrumb } = useBreadCrumb();
	const toast = useToast();
	const { setLoading } = useLoader();
	const { id } = useParams();
	const [assessmentConfig, setAssessmentConfig] = useState<AssessmentConfig>({
		cutOfScore: "75",
		validity_days: "2",
		behavioralAssessment: {
			checkSection: true,
			numQuestions: "4",
			questionLevel: "Medium",
			topic: "",
			codingLanguage: ""
		},
		technicalAssessment: {
			checkSection: false,
			numQuestions: "3",
			questionLevel: "Hard",
			topic: "",
			codingLanguage: ""
		},
		codingAssessment: {
			checkSection: false,
			numQuestions: "2",
			questionLevel: "Easy",
			topic: "",
			codingLanguage: ""
		}
	});





	const validateAssessment = (): boolean => {
		if (parseFloat(assessmentConfig.cutOfScore) < 1 || !(assessmentConfig.cutOfScore)) {
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Invalid Score",
				description: "Minimum qualification score must be at least 1%. Please enter a value between 1 and 100.",
				open: true,
			});
			return false
		}
		if (parseFloat(assessmentConfig.validity_days) < 1 || !assessmentConfig.validity_days) {
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Invalid Validity Period",
				description: "Assessment link validity must be at least 1 day. Please enter a valid number of days.",
				open: true,
			});
			return false
		}

		const requiredFieldsBySection: Record<keyof AssessmentConfig, string[]> = {
			cutOfScore: [],
			validity_days: [],
			behavioralAssessment: ["numQuestions", "questionLevel"],
			technicalAssessment: ["numQuestions", "questionLevel"],
			codingAssessment: ["numQuestions", "questionLevel", "codingLanguage"],
		};

		for (const section in requiredFieldsBySection) {
			const typedSection = section as keyof AssessmentConfig;
			const sectionConfig = assessmentConfig[typedSection] as AssessmentSection;
			if (sectionConfig?.checkSection) {
				for (const field of requiredFieldsBySection[typedSection]) {
					if (!sectionConfig[field as keyof AssessmentSection]) {
						toast.error({
							type: "background",
							duration: 5000,
							status: "error",
							title: "Incomplete Assessment",
							description: `Please select "${field === "numQuestions" ? "Number of Questions" : field === "questionLevel" ? "Difficulty Level" : "Programming Language"}" in ${section.split("Assessment")[0][0].toUpperCase() + section.split("Assessment")[0].slice(1)} Assessment.`,
							open: true,
						});
						return false;
					}
				}
			}
		}

		return true;
	};
	const getAssessmentConfigPayload = () => {
		return {
			cutOfScore: assessmentConfig.cutOfScore,
			validity_days: assessmentConfig.validity_days,
			behavioralAssessment: {
				numQuestions: assessmentConfig.behavioralAssessment.checkSection ? assessmentConfig.behavioralAssessment.numQuestions : 0,
				questionLevel: assessmentConfig.behavioralAssessment.questionLevel,

			},
			technicalAssessment: {

				numQuestions: assessmentConfig.technicalAssessment.checkSection ? assessmentConfig.technicalAssessment.numQuestions : 0,
				questionLevel: assessmentConfig.technicalAssessment.questionLevel,
				topic: assessmentConfig.technicalAssessment.topic,

			},
			codingAssessment: {
				numQuestions: assessmentConfig.codingAssessment.checkSection ? assessmentConfig.codingAssessment.numQuestions : 0,
				questionLevel: assessmentConfig.codingAssessment.questionLevel,
				topic: assessmentConfig.codingAssessment.topic,
				codingLanguage: assessmentConfig.codingAssessment.codingLanguage
			}
		}
	}

	const generateAssessment = async () => {
		if (!validateAssessment()) return;
		setLoading(true);
		const assessmentConfig = getAssessmentConfigPayload()
		try {
			const response = await api.post(`generate_assessment_questions`, {
				job_id: id,
				assessmentConfig,
			});
			if (response.status === 200) {

				setTimeout(() => {
					setLoading(false);
					toast.success({
						type: "background",
						duration: 3000,
						status: "Success",
						title: "Assessmented Generated Successfully",
						description: "",
						open: true,
					});
					window.history.back();
				}, 2000);
			}
		} catch (error: any) {
			setLoading(false);

			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Generating Assessment",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to generate assessment. Please try again.",
				open: true,
			});
		}
	};

	useEffect(() => {
		setBreadCrumb({
			mainLabel: {
				label: "Applicants",
				link: `respective-dashboard/${id}`,
			},
			currentLabel: "Generate Assessment",
		});
	}, []);
	return (
		<div className="bg-white p-4 rounded-xl w-full min-h-[85vh]">
			<div className="flex items-center mb-3">
				<button onClick={() => window.history.back()} className="mr-4">
					<svg
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10.0156 0.733192L4.23077 6.51522C3.9374 6.7947 3.9374 7.23141 4.23077 7.51089L10.0156 13.2929"
							stroke="#7F7F7F"
							strokeMiterlimit="2.613"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
				<h2 className="md:text-2xl text-left text-lg font-bold text-gray-800 my-4 font-heading">
					Generate Assessment
				</h2>
			</div>
			<AssessmentForm
				assessmentConfig={assessmentConfig}
				setAssessmentConfig={setAssessmentConfig}
			/>
			<div className="w-full flex justify-center mt-10">
				<button
					onClick={generateAssessment}
					className=" bg-[#BDE4C3] text-[#438437] px-5 py-2.5 rounded-md  hover:scale-110 transition"
				>
					Generate
				</button>
			</div>
		</div>
	);
};

export default GenerateAssessmentLaterPage;
